export const environment = {
  production: true,
  api: "https://api.serp.alfayomega.com.gt/",
  defaultTheme: "yellow-theme"
};

